import React, { useEffect, useRef, useState } from 'react'
import { Dashboard } from '@uppy/react'
import '@uppy/core/dist/style.min.css'
import '@uppy/dashboard/dist/style.min.css'
import './upload-dashboard.css'
import { usePageContext } from '../../../context/page.context'
import { useTransferContext } from '../transfer-provider'

// Inline, themed Uppy Dashboard for a single large file uploaded direct-to-S3
// via our presigned multipart endpoints. Device/drag-drop only, no branding.
export const UploadDashboard = ({ base, path, initParams, allowedFileTypes, maxFileSize, onComplete, endpointGroup, targetId }) => {
  const { getOrCreateUpload, releaseUpload } = useTransferContext()
  const [uppy] = useState(() => getOrCreateUpload({
    endpointGroup,
    targetId,
    base,
    path,
    initParams,
    restrictions: { maxNumberOfFiles: 1, allowedFileTypes, maxFileSize },
    gotoPath: window.location.pathname,
  }))

  // Follow the admin site's own theme toggle (body[data-bs-theme]) so Uppy's
  // structural light/dark colors track the page; accents are branded in CSS.
  const pageContext = usePageContext()
  const isDark = !!pageContext?.theme?.isDark

  const onCompleteRef = useRef(onComplete)
  useEffect(() => { onCompleteRef.current = onComplete }, [onComplete])

  useEffect(() => {
    const handler = (result) => {
      if (result.successful && result.successful.length) {
        onCompleteRef.current && onCompleteRef.current()
      }
    }
    uppy.on('complete', handler)
    return () => {
      uppy.off('complete', handler)
      releaseUpload(targetId)   // destroy ONLY if no files remain; keep alive if uploading
    }
  }, [uppy, releaseUpload, targetId])

  return (
    <div className="exr-uppy">
      {/* metaFields adds the per-file "Notes" edit (pencil) affordance — Uppy's
          native metadata pattern, and the closest match to the old uploader's
          "add note" link. The value reaches the backend `note` column via
          file.meta.note -> the adapter's /init body. */}
      <Dashboard
        uppy={uppy}
        inline
        theme={isDark ? 'dark' : 'light'}
        width="100%"
        height={380}
        proudlyDisplayPoweredByUppy={false}
        note={`Accepted: ${(allowedFileTypes || []).join(' · ') || 'any'} — one file`}
        metaFields={[{ id: 'note', name: 'Notes', placeholder: 'optional note' }]}
        showProgressDetails
      />
    </div>
  )
}
